import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import {
  Grid,
  Divider as MuiDivider,
  Typography as MuiTypography,
} from "@mui/material";
import { spacing } from "@mui/system";
import { green, red } from "@mui/material/colors";

import Actions from "./Actions";
import LineChartCard from "src/components/Charts/LineChartCard";
import DoughnutChartCard from "src/components/Charts/DoughnutChartCard";
import BarChartCard from "src/components/Charts/BarChartCard";
import StatsCard from "src/components/Charts/StatsCard";
import Table from "./Table";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

function Default({ theme }) {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Helmet title="Default Dashboard" />
      {/* <Grid justifyContent="space-between" container spacing={6}>
        <Grid item>
          <Typography variant="h3" gutterBottom>
            Default Dashboard
          </Typography>
         <Typography variant="subtitle1">
            {t("Welcome back")}, Lucy! {t("We've missed you")}.{" "}
            <span role="img" aria-label="Waving Hand Sign">
              👋
            </span>
          </Typography>  
        </Grid>

        <Grid item>
          <Actions />
        </Grid>
      </Grid> 

      <Divider my={6} />
*/}
      <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <StatsCard
            title="Sales Today"
            apiUrl="statsSalestoday"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <StatsCard
            title="Visitors"
            apiUrl="statsVisitors"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <StatsCard
            title="Total Earnings"
            apiUrl="statsEarnings"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3} xl>
          <StatsCard
            title="Pending Orders"
            apiUrl="statsOrders"
          />
        </Grid>
      </Grid>

      <Grid container spacing={6}>
        <Grid item xs={12} lg={8}>
          <LineChartCard
            title="Total revenue"
            apiUrl="Dashboard/revenue"
            theme={theme}
            mb={6}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <DoughnutChartCard
            title="Weekly sales"
            apiUrl="Dashboard/doughnut"
            theme={theme}
            mb={6}
          />
        </Grid>
      </Grid>
      <Grid container spacing={6}>
        <Grid item xs={12} lg={4}>
          <BarChartCard
            title="Mobile / Desktop"
            apiUrl="Dashboard/bar"
            theme={theme}
            mb={6}
          />
        </Grid>
        <Grid item xs={12} lg={8}>
          <Table />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default withTheme(Default);
